import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/order_complete";

export default class OrderComplete extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
  }
}
